import { render, staticRenderFns } from "./OffersHome.vue?vue&type=template&id=a8505724&scoped=true&"
import script from "./OffersHome.vue?vue&type=script&lang=js&"
export * from "./OffersHome.vue?vue&type=script&lang=js&"
import style0 from "./OffersHome.vue?vue&type=style&index=0&id=a8505724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8505724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VSpacer})
